import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import OrganisationEditor from "../organisation-editor";

const ContactOrganisationsCreate = () => {
  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Neues Unternehmen erstellen</PageTitle>
        </div>
      </PageTitleContainer>
      <div className="p-4 w-1/2 items-center m-auto">
        <OrganisationEditor />
      </div>
    </div>
  );
};

export default ContactOrganisationsCreate;
